module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold.a0c781a9.woff2";